"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _customerCoupon = require("@/api/activity/customerCoupon");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'authOrg',
  data: function data() {
    return {
      roleList: [],
      ruleList: [],
      // 搜索表单
      searchForm: {
        name: '',
        chMobile: '',
        page: 1,
        limit: 10,
        total: 0
      },
      // 数据列表
      orgList: [],
      // 弹窗状态
      dialogVisible: false,
      // 表单数据
      form: {
        roleIds: '',
        chPersonCode: '',
        chPersonName: '',
        chMobile: '',
        chProductTypeDept: '',
        chRoleName: '',
        chStoreCodePos: '',
        chStoreNamePos: '',
        chStoreCodeKingdee: '',
        chJobTitileName: '',
        chO2oStoreCodePos: ''
      },
      loading: false,
      submitLoading: false
    };
  },
  mounted: function mounted() {
    this.getOrgList();
    this.getAuthOrgRule();
    this.getAuthOrgRole();
  },
  methods: {
    getRoleName: function getRoleName(roleId) {
      var role = this.roleList.find(function (role) {
        return role.id === roleId;
      });
      return role ? role.name : '';
    },
    handleRoleChange: function handleRoleChange(value) {
      // 检查是否选中了 id 为 0 的选项
      var hasZero = value.includes(0);
      if (hasZero) {
        // 如果选中了0，只保留0，移除其他选项
        this.form.roleIds = [0];
        this.$message.warning('选择无权限后不能选择其他角色');
      } else {
        // 正常多选其他角色
        this.form.roleIds = value;
      }
    },
    getAuthOrgRole: function getAuthOrgRole() {
      var _this = this;
      (0, _customerCoupon.getAuthOrgRole)().then(function (res) {
        if (res.code == 200) {
          _this.roleList = res.data || [];
        } else {
          _this.$message.error(res.msg || '查询失败');
        }
      });
    },
    getAuthOrgRule: function getAuthOrgRule() {
      var _this2 = this;
      (0, _customerCoupon.getAuthOrgRule)().then(function (res) {
        if (res.code === 200) {
          _this2.ruleList = res.data || [];
        } else {
          _this2.$message.error(res.msg || '查询失败');
        }
      });
    },
    // 获取数据列表
    getOrgList: function getOrgList() {
      var _this3 = this;
      this.loading = true;
      (0, _customerCoupon.getAuthOrg)(this.searchForm).then(function (res) {
        if (res.code === 200) {
          _this3.orgList = res.data.list || [];
          _this3.searchForm.total = res.data.total || 0;
        } else {
          _this3.$message.error(res.msg || '查询失败');
        }
      }).finally(function () {
        _this3.loading = false;
      });
    },
    // 搜索
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getOrgList();
      this.getAuthOrgRole();
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getOrgList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getOrgList();
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      console.log(row);
      this.form = _objectSpread({}, row);
      this.dialogVisible = true;
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          _this4.submitLoading = true;
          // 选了“无权限”(id=0)则有效期置为当前（立即过期），否则长期有效
          var hasNoPermRole = (_this4.form.roleIds || []).includes(0);
          var payload = _objectSpread({}, _this4.form);
          payload.periodOfValidity = hasNoPermRole ? new Date() : new Date(2099, 11, 31, 23, 59, 59);
          (0, _customerCoupon.updateAuthOrg)(payload).then(function (res) {
            if (res.code === 200) {
              _this4.$message.success('保存成功');
              _this4.dialogVisible = false;
              _this4.getOrgList();
            } else {
              _this4.$message.error(res.msg || '保存失败');
            }
          }).finally(function () {
            _this4.submitLoading = false;
          });
        }
      });
    },
    // 格式化日期
    formatDate: function formatDate(date) {
      if (!date) return '';
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var hours = String(d.getHours()).padStart(2, '0');
      var minutes = String(d.getMinutes()).padStart(2, '0');
      var seconds = String(d.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
  }
};